<template>
  <div class="wrap">
    <div id="full-screen">
      <div class="edit-header">
      <div class="left">
        <span>编辑脚本</span>
        <el-popover
          placement="'bottom-start'"
          width="400"
          trigger="hover"
          :content="popText">
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </div>
      <div class="right">
        <span>脚本语言：</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in langOptions"
            :key="item.id"
            :label="item.lang"
            :value="item.lang">
          </el-option>
        </el-select>
        <!-- 放大按钮 -->
        <i :class="['iconfont',isFullscreen? 'icon-ziyuanldpi':'icon-ziyuanldpi1' ,'screeng']" @click="screen"></i>
      </div>
    </div>
    <!-- 编辑器容器 -->
      <editor
        ref="editor"
        class="edit"
        theme="chrome"
        v-model="content"
        width="100%"
        :height="isFullscreen? 'calc(100% - 54px)': '428'"
        :lang="value"
        :options="editorOptions"
        @init="editorInit"
      ></editor>
    </div>
    <!-- tabs -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="模拟输入" name="first" class="first">
        <el-row type="flex" class="options">
          <!-- type -->
          <div style="margin-right:10px">
            <el-select v-model="topicType" clearable placeholder="请选择模拟类型" @clear="clearType">
              <el-option
                v-for="item in simOptions"
                :key="item.id"
                :label="item.name"
                :value="item.topicType">
              </el-option>
            </el-select>
          </div>
          <!-- device -->
          <div style="margin-right:10px">
            <el-select v-model="deviceName" clearable placeholder="请选择设备" @clear="clearDevice">
              <el-option
                v-for="item in devOptions"
                :key="item.id"
                :label="item.deviceName"
                :value="item.deviceName">
              </el-option>
            </el-select>
          </div>
          <!-- topic -->
          <div>
            <el-select v-model="topicClass" clearable placeholder="请选择模拟输入topic" style="width:100%" :disabled="deviceName === '' || topicType === ''">
              <el-option
                v-for="item in topOptions"
                :key="item.id"
                :label="item.topicClass"
                :value="item.topicClass">
              </el-option>
            </el-select>
          </div>
        </el-row>
        <el-row class="texts">
          <el-input
            :autosize="{ minRows: 6}"
            :disabled="topicClass ==='' || deviceName ==='' || topicType === ''"
            type="textarea"
            placeholder="// 二进制数据以0x开头的十六进制输入，字符串数据输入原始字符串"
            v-model="textarea">
          </el-input>
        </el-row>
        <el-row class="buttons">
            <!-- <el-button  @click="save" :disabled="textarea === ''">提交</el-button> -->
            <el-tooltip class="item" effect="light" content="脚本和模拟数据不能为空" placement="top" :disabled="content !== '' || textarea !== ''">
              <el-col :span="1.8">
                <el-button @click="run" :disabled="content === '' || textarea === ''">运行<i class="el-icon-caret-right el-icon--right" style="font-size:14px"></i></el-button>
              </el-col>
            </el-tooltip>
          <el-col :span="1.8" style="margin-left:10px">
            <el-button @click="save" :disabled="textarea === ''">保存<i class="el-icon-document el-icon--right" style="font-size:14px"></i></el-button>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="运行结果" name="second" class="second">
        <el-row class="title">
         {{` 输出topic: "` + outputTopic + `"`}}
        </el-row>
        <el-row class="texts">
          <el-input
            :autosize="{ minRows: 6}"
            class="result-color"
            ref="resultText"
            type="textarea"
            placeholder=""
            v-model="outputText">
          </el-input>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import screenfull from 'screenfull' // 引入全屏显示
import { topicType, deviceName, topicClass, query, handle, add } from '@/api/productRegistration'
// import { topicType, deviceName, topicClass, query, add } from '@/api/productRegistration'
export default {
  components: {
    editor: require('vue2-ace-editor')
  },
  data () {
    return {
      popText: '编写数据解析脚本，透传类设备上报数据时会自动调用脚本将数据解析为 Alink JSON 格式，您可以对脚本进行模拟和运行调试，运行正常后点击“提交”，发布该脚本，脚本文件大小上限是 48KB',
      deviceInfos: {},
      value: 'javascript',
      langOptions: [
        {
          id: 0,
          lang: 'javascript'
        }
      ],
      // 编辑器内容设置
      content: '',
      editorOptions: {
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableLiveAutocompletion: true,
        tabSize: 1,
        fontSize: 12,
        showPrintMargin: false // 去除编辑器里的竖线
      },
      // tabs
      activeName: 'first',
      // 选项
      simOptions: [], // 模拟类型列表
      topOptions: [], // topic列表
      devOptions: [], // 设备列表
      topicType: '',
      deviceName: '',
      topicClass: '',
      textarea: '', // 输入参数
      // second
      outputTopic: '',
      outputText: '', // 输出结果
      isFullscreen: false
    }
  },
  created () {
    if (localStorage.getItem('infos')) {
      this.deviceInfos = JSON.parse(localStorage.getItem('infos'))
    } else {
      this.deviceInfos = JSON.parse(this.$route.query.sRow)
    }
    // console.log(this.deviceInfos)
    this.getTopicType()
    this.getDeviceName()
    this.getScript()
  },
  watch: {
    deviceName: {
      handler (val) {
        console.log(val)
        if (val !== '' && this.topicType !== '') this.getTopic()
      },
      immediate: true
    },
    topicType: {
      handler (val) {
        if (val !== '' && this.deviceName !== '') this.getTopic()
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    editorInit: function () {
      require('brace/ext/language_tools') // language extension prerequsite...
      // require('brace/mode/html')
      require('brace/mode/javascript') // language
      // require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/snippets/javascript') // snippet
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    run () {
      // console.log(this.textarea)
      // console.log(JSON.stringify(this.$refs.editor.value))
      const params = {
        productKey: this.deviceInfos.productKey,
        scriptContent: this.content,
        topic: this.topicClass,
        data: this.textarea
      }
      handle({ params }).then(res => {
        if (res.data.code === 200) {
          let result = ''
          if (res.data.data.indexOf('{') !== -1) {
            result = JSON.parse(res.data.data)
            this.$refs.resultText.$refs.textarea.style.color = ''
          } else {
            result = res.data.data
            this.$refs.resultText.$refs.textarea.style.color = 'red'
          }
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.outputText = JSON.stringify(result, null, 2)
          result.topic ? this.outputTopic = result.topic : this.outputTopic = ''
          this.activeName = 'second'
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      })
    },
    // 保存
    save () {
      const params = {
        productKey: this.deviceInfos.productKey,
        scriptContent: this.content
      }
      add({ params }).then(res => {
        console.log(res.data.code)
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        }
      })
    },
    // 全屏
    screen () {
      const element = document.getElementById('full-screen')
      if (!screenfull.isEnabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      // screenfull.request(element)
      screenfull.toggle(element)
    },
    change () {
      console.log(screenfull.isFullscreen)
      this.isFullscreen = screenfull.isFullscreen
    },
    init () {
      if (screenfull.isEnabled) {
        console.log(111)
        screenfull.on('change', this.change)
      }
    },
    destroy () {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    },
    // 获取脚本信息
    getScript () {
      const params = {
        productKey: this.deviceInfos.productKey
      }
      query({ params }).then((res) => {
        if (JSON.stringify(res.data.data) !== '{}') {
          this.content = res.data.data.scriptContent
        } else {
          this.content =
`/**
* 将设备自定义topic数据转换为json格式数据, 设备上报数据到物联网平台时调用
* 入参：topic string 设备上报消息的 topic  
* 入参：rawData byte[] 数组 不能为空  
* 出参：jsonObj JSON 对象 不能为空  
*/  
function transformPayload(topic, rawData) {
    var jsonObj = {};
    return jsonObj;
}`
        }
      })
    },
    // 获取topic类型
    getTopicType () {
      const params = {
        productKey: this.deviceInfos.productKey
      }
      topicType({ params }).then((res) => {
        this.simOptions = res.data.data
        this.simOptions.forEach((res) => {
          res.topicType === 1 ? res.name = '基础通信Topic' : res.topicType === 2 ? res.name = '物模型通信Topic' : res.topicType === 3 ? res.name = '自定义topic' : res.name = '子设备topic'
        })
      })
    },
    // 获取deviceName
    getDeviceName () {
      const params = {
        productKey: this.deviceInfos.productKey
      }
      deviceName({ params }).then((res) => {
        this.devOptions = res.data.data
      })
    },
    // 获取topic
    getTopic () {
      const params = {
        productKey: this.deviceInfos.productKey,
        deviceName: this.deviceName,
        topicType: this.topicType
      }
      topicClass({ params }).then((res) => {
        console.log(res)
        this.topOptions = res.data.data
      })
    },
    clearType () {
      this.topicClass = ''
    },
    clearDevice () {
      this.topicClass = ''
    }
  }
}
</script>

<style lang='less' scoped>
  .result-color{
    color:red !important;
  }
  /* /deep/ .ace_scrollbar-v{
    overflow-y: hidden;
  } */
  /* #full-screen{
    overflow-y: scroll;
  } */
  .edit-header{
    padding: 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background: #f9f9f9;
    border: 1px solid #ebecec;
    font-size: 14px;
    .left{
      span{
        color:#111111;
        margin-right: 6px;
      }
      i{
        color:#ccc
      }
    }
    .right{
      span{
        color: #9B9EA0;
      }
      /deep/ .el-input__inner{
        border-radius: 0px;
        height: 36px;
        line-height: 36px;
      }
      .screeng{
        margin-left: 20px;
        color: #303133;
        cursor: pointer;
      }
    }
  }
  .edit{
    touch-action:none
  }
  /deep/ .el-tabs__header{
    border: 1px solid #ebecec;
    background-color:#f9f9f9;
    margin:0px
  }
  /deep/ .el-tabs__nav{
    margin-left: 12px;
  }
  /deep/ .el-tabs__content{
    border: 1px solid #ebecec;
    border-top: 0;
    padding: 16px 12px;
  }
  .first{
    .options{
      margin-bottom: 10px;
      /deep/ .el-input__inner{
        border-radius: 0px;
        height: 36px;
        line-height: 36px;
      }
    }
    .texts{
      margin-bottom: 10px;
    }
    .buttons{
      .el-button{
        padding: 10px 15px;
        border-radius: 0px;
      }
    }
  }
  .second{
    .title{
      margin-bottom: 10px;
    }
  }
</style>
